import React, { Component } from 'react';
import { Card, Icon, Tooltip } from 'material-ui';
import { withStyles } from 'material-ui/styles/index';
import classNames from 'classnames';
import GoogleMap from 'google-map-react';
import ReactTable from "react-table";
import axios from 'axios';

const styles = theme => ({
    root: {}
});

function Marker({ text }) {

    return (
        <Tooltip title={text} placement="top">
            <Icon className="text-red">place</Icon>
        </Tooltip>
    );
}

class Widget6 extends Component {

    constructor(props) {
        super(props);

        this.state = {
            data: [],
            custName: ""
        }

        this.loadJobDetails();
    }

    loadJobDetails() {

        axios.get(window.crmServer + '/job/all')
            .then(response => {

                if (response == undefined || response == null || response == "" || 0 == response.data.length) {
                    console.log("//////////error//////////Widget6//////////////////");
                } else {
                    this.loadDataAll(response);


                }

            }).catch(function (error) {

                console.log("err VIDGET 6 : " + error);
                console.log("No internet connection or Internal error");
                // this.props.alert.error("No internet connection or Internal error !");
            });
    }

    loadDataAll(response1) {

        for (let i = 0; i < response1.data.length; i++) {

            let custId = response1.data[i].CUSTOMER_ID;
            axios.post(window.crmServer + '/crm/getCustomer/byId', { id: custId })
                .then(response => {
                    // alert("s" + response.data[0].CUSTOMER_PROFILE.cx_name);
                    // var data1 = [];

                    // this.setState({custName :  });
                    if (null == response.data || undefined == response.data || 0 == response.data.length) {
                        console.log("Caustomer profile has no data");
                    } else {
                        var data1 = {
                            jobId: response1.data[i].ID_JOB_PROFILE,
                            jobNo: response1.data[i].JOB_CODE,
                            customer: response.data[0].CUSTOMER_PROFILE.cx_name,
                            receivedDate: (response1.data[i].SERVICE_DATE).split("T")[0],
                            expectedDate: (response1.data[i].EXPECTED_DATE).split("T")[0],
                            completePres: response1.data[i].PROGRESS,
                            priority: response1.data[i].PRIORITY_LEVEL,

                        };
                        // this.setState({ data: data1 });

                        var newStateArray = this.state.data.slice();
                        newStateArray.push(data1);
                        this.setState({ data: newStateArray });
                    }
                });
        }

    }

    render() {
        const { data, classes } = this.props;
        return (
            <Card className={classNames(classes.root, "w-full")}>
                <ReactTable className="w-full"
                    getTrProps={(state, rowInfo, column) => {
                        return {
                            className: "cursor-pointer",
                            onClick: (e, handleOriginal) => {

                            }
                        }
                    }}
                    data={this.state.data}
                    columns={[

                        {
                            Header: "job id",
                            accessor: "jobId",
                            show: false
                        },

                        {
                            Header: "Job No",
                            accessor: "jobNo",
                            // show: false,
                            filterable: true
                        },
                        {
                            Header: "Customer",
                            accessor: "customer",
                            filterable: true

                        },
                        {
                            Header: "Received Date",
                            accessor: "receivedDate",
                            filterable: true

                        },

                        {
                            Header: "Expected Date",
                            accessor: "expectedDate",
                            filterable: true

                        },

                        {
                            Header: "Complete (%)",
                            accessor: "completePres",
                            filterable: true

                        },

                        {
                            Header: "Priority",
                            accessor: "priority",
                            filterable: true

                        },

                    ]}
                    defaultPageSize={5}
                    className="-striped -highlight"
                />

            </Card>
        );
    }
}

export default withStyles(styles, { withTheme: true })(Widget6);



// WEBPACK FOOTER //
// ./src/main/content/apps/dashboards/widgets/Widget6.js